<template>
  <el-dialog 
    :title="getDialogTitle" 
    :visible.sync="dialogVisible" 
    width="88%" 
    :close-on-click-modal="false"
    :before-close="handleClose" 
    top="2vh" 
    custom-class="addxyk-dialog"
  >
    <div class="dialog-container">
      <!-- 上部分：采购信息 -->
      <div class="purchase-info-section">
        <h3 class="section-title">采购信息</h3>
        <el-form 
          ref="purchaseForm" 
          :model="purchaseForm" 
          :rules="purchaseRules" 
          label-width="120px" 
          size="mini"
        >
          <el-row :gutter="20">
            <!-- 出库药库 -->
            <el-col :span="8">
              <el-form-item label="出库药库：" prop="warehouseId">
                <el-select 
                  v-model="purchaseForm.warehouseId" 
                  placeholder="请选择出库药库" 
                  clearable
                  style="width: 100%"
                  @change="handleWarehouseChange"
                  :disabled="true"
                  size="mini"
                >
                  <el-option
                    v-for="item in warehouseOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            
            <!-- 业务日期（禁用状态默认当前日期） -->
            <el-col :span="8">
              <el-form-item label="业务日期：" prop="businessDate">
                <el-date-picker
                  v-model="purchaseForm.businessDate"
                  type="date"
                  placeholder="选择日期"
                  style="width: 100%"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :disabled="true"
                  size="mini"
                />
              </el-form-item>
            </el-col>
            
            <!-- 出库科室 -->
            <el-col :span="8">
              <el-form-item label="出库科室：" prop="deptId">
                <el-select
                  v-model="purchaseForm.deptId"
                  placeholder="请选择出库科室"
                  clearable
                  style="width: 100%"
                  :disabled="currentMode !== 'add' && currentMode !== 'edit'"
                  size="mini"
                >
                  <el-option
                    v-for="item in deptOptions"
                    :key="item.id"
                    :label="item.deptName"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <!-- 供货单位 + 供应商号码 -->
            <el-col :span="8">
              <el-form-item label="供货单位：" prop="supplierId">
                <div class="supplier-container">
                  <el-select
                    v-model="purchaseForm.supplierId"
                    placeholder="请选择供货单位"
                    clearable
                    style="flex: 1"
                    :disabled="currentMode !== 'add' && currentMode !== 'edit'"
                    @change="handleSupplierChange"
                    size="mini"
                  >
                    <el-option
                      v-for="item in supplierOptions"
                      :key="item.id"
                      :label="item.supplierName"
                      :value="item.id"
                    />
                  </el-select>
                  <el-input
                    v-model="purchaseForm.supplierNo"
                    placeholder="供应商号码"
                    style="width: 150px; margin-left: 10px"
                    :disabled="currentMode !== 'add' && currentMode !== 'edit'"
                    size="mini"
                  />
                </div>
              </el-form-item>
            </el-col>
            
            <!-- 出库方式 -->
            <el-col :span="8">
              <el-form-item label="出库方式：" prop="outTypeId">
                <el-select
                  v-model="purchaseForm.outTypeId"
                  placeholder="请选择出库方式"
                  clearable
                  style="width: 100%"
                  :disabled="currentMode !== 'add' && currentMode !== 'edit'"
                  size="mini"
                >
                  <el-option
                    v-for="item in outTypeOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 员工下拉选择框 -->
            <el-col :span="8">
              <el-form-item label="员工：" prop="staffId">
                <el-select
                  v-model="purchaseForm.staffId"
                  placeholder="请选择员工"
                  clearable
                  style="width: 100%"
				  popper-class="drug-select-popper"
                  :disabled="!purchaseForm.deptId || (currentMode !== 'add' && currentMode !== 'edit')"
                  :loading="staffLoading"
                  size="mini"
                >
                  <el-option
                    v-for="item in staffOptions"
                    :key="item.id"
                    :label="item.staffName"
                    :value="item.id"
                  >
                    <div style="display: flex; flex-direction: column; line-height: 1.4; padding: 4px 0;">
                      <span style="font-weight: 500; color: #303133;">{{ item.staffName }}</span>
                      <span style="font-size: 12px; color: #8492a6;">编号：{{ item.titleName || '无职称' }}</span>
                    </div>
                  </el-option>
                  
                  <!-- 无数据提示 -->
                  <el-option
                    v-if="!staffLoading && staffOptions.length === 0 && purchaseForm.deptId"
                    key="no-staff"
                    disabled
                    style="text-align: center; color: #909399; font-size: 12px;"
                  >
                    该科室暂无医生
                  </el-option>
                  
                  <!-- 未选择科室提示 -->
                  <el-option
                    v-if="!purchaseForm.deptId"
                    key="no-dept"
                    disabled
                    style="text-align: center; color: #909399; font-size: 12px;"
                  >
                    请先选择出库科室
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            
          </el-row>
		  <el-row>
			<!-- 备注 -->
			<el-col :span="24">
			  <el-form-item label="备注：" prop="remarks">
			    <el-input
			      v-model="purchaseForm.remarks"
			      placeholder="请输入备注"
				  type="textarea"
			      :disabled="currentMode !== 'add' && currentMode !== 'edit'"
			      size="mini"
			    />
			  </el-form-item>
			</el-col>
		  </el-row>
        </el-form>
      </div>
      
      <!-- 下部分：药品出库明细列表 -->
      <div class="medicine-detail-section">
        <!-- 在药品出库明细列表标题右侧 -->
        <div class="section-header">
          <h3 class="section-title">卫材出库明细列表</h3>
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-plus"
            @click="addMedicineRow"
            v-if="currentMode === 'add' || currentMode === 'edit'"
            :disabled="!purchaseForm.warehouseId"
          >
            添加卫材
          </el-button>
        </div>
        
        <!-- 药品明细表格 -->
        <el-table
          :data="medicineList"
          style="width: 100%"
          stripe
          border
          size="mini"
          max-height="400px"
          v-loading="tableLoading"
        >
          <!-- 行号 -->
          <el-table-column
            type="index"
            label="#"
            width="60"
            align="center"
            fixed
          />
          
          <!-- 药品名称 -->
          <el-table-column
            prop="eisaiName"
            label="药品名称"
            min-width="180"
            align="center"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.isLocked && !scope.row.isEditing">
                {{ scope.row.eisaiName || '--' }}
              </template>
              <template v-else>
                <!-- 药品名称下拉框 -->
                <el-select
                  v-model="scope.row.eisaiId"
                  placeholder="请选择药品"
                  clearable
                  filterable
                  style="width: 100%"
                  :disabled="(currentMode === 'edit' && scope.row.isLocked && !scope.row.isEditing) || currentMode === 'view' || currentMode === 'submit' || currentMode === 'review' || currentMode === 'pass'"
                  @change="(value) => handleDrugChange(value, scope.row, scope.$index)"
                  size="mini"
                >
                  <!-- 修改key绑定，使用复合key避免重复 -->
                  <el-option
                    v-for="(item, index) in drugOptions"
                    :key="`${item.eisaiId}-${index}`"
                    :label="item.eisaiName"
                    :value="item.eisaiId"
                  >
                    <div style="display: flex;flex-direction: column;line-height: 1.4; padding: 8px 0;">
                      <div style="display: flex; justify-content: space-between; align-items: center;">
                        <span style="font-weight: 500; color: #303133;">{{ item.eisaiName }}</span>
                        <span style="font-size: 12px; color: #8492a6;">批次号：{{ item.manuLotnum || '无批次' }}</span>
                      </div>
                      <div style="font-size: 12px; color: #606266; margin-top: 4px;">
                        规格：{{ item.specDesc }}
                      </div>
                    </div>
                  </el-option>
                  
                  <!-- 加载更多选项 -->
                  <el-option
                    v-if="drugOptions.length > 0 && drugOptions.length < totalDrugs"
                    key="load-more"
                    disabled
                    style="text-align: center;"
                  >
                    <el-button
                      type="text"
                      size="mini"
                      :loading="drugLoading"
                      @click="loadMoreDrugs"
                      style="width: 100%;"
                    >
                      加载更多...
                    </el-button>
                  </el-option>
                  
                  <!-- 无数据提示 -->
                  <el-option
                    v-if="!drugLoading && drugOptions.length === 0"
                    key="no-data"
                    disabled
                    style="text-align: center; color: #909399;"
                  >
                    暂无数据
                  </el-option>
                </el-select>
              </template>
            </template>
          </el-table-column>
          
          <!-- 出库数量 -->
          <el-table-column
            label="出库数量"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.isLocked && !scope.row.isEditing">
                {{ scope.row.outQuantity || '--' }}{{ scope.row.unit ? ' ' + scope.row.unit : '' }}
              </template>
              <template v-else>
                <div class="out-quantity-container" style="display: flex; align-items: center; gap: 8px;">
                  <!-- 出库数量输入框 -->
                  <el-input
                    v-model="scope.row.outQuantity"
                    placeholder="请输入数量"
                    style="width: 120px"
                    :disabled="currentMode !== 'add' && currentMode !== 'edit' || (scope.row.isLocked && !scope.row.isEditing) || !scope.row.eisaiId"
                    @input="(value) => handleQuantityChange(value, scope.row, scope.$index)"
                    size="mini"
                  />
                  <!-- 单位文字独立显示 -->
                  <span style="color: #606266; font-size: 12px; min-width: 30px;">
                    {{ scope.row.unit || '--' }}
                  </span>
                </div>
              </template>
            </template>
          </el-table-column>
          
          <!-- 库存类型 -->
          <el-table-column
            label="库存类型"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.isLocked && !scope.row.isEditing">
                {{ scope.row.stockType === 1 ? '最小单位' : '包装单位' }}
              </template>
              <template v-else>
                <!-- 库存类型下拉框 -->
                <el-select
                  v-model="scope.row.stockType"
                  placeholder="库存类型"
                  style="width: 100%"
                  :disabled="currentMode !== 'add' && currentMode !== 'edit' || (scope.row.isLocked && !scope.row.isEditing)"
                  @change="(value) => handleStockTypeChange(value, scope.row)"
                  size="mini"
                >
                  <el-option label="最小单位" :value="1" />
                  <el-option label="包装单位" :value="2" />
                </el-select>
              </template>
            </template>
          </el-table-column>
          
          <!-- 包装数量 -->
          <el-table-column
            prop="pacCnt"
            label="包装数量"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.pacCnt || '--' }}
            </template>
          </el-table-column>
          
          <!-- 生产厂家 -->
          <el-table-column
            prop="prodentpName"
            label="生产厂家"
            width="150"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.prodentpName || '--' }}
            </template>
          </el-table-column>
          
          <!-- 生产批号 -->
          <el-table-column
            prop="manuLotnum"
            label="生产批号"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.manuLotnum || '--' }}
            </template>
          </el-table-column>
          
          <!-- 生产日期 -->
          <el-table-column
            prop="manuDate"
            label="生产日期"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              {{ formatDate(scope.row.manuDate) || '--' }}
            </template>
          </el-table-column>
          
          <!-- 有效期 -->
          <el-table-column
            prop="expyDate"
            label="有效期"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              {{ formatDate(scope.row.expyDate) || '--' }}
            </template>
          </el-table-column>
          
          <!-- 入库成本 -->
          <el-table-column
            prop="purcPric"
            label="入库成本"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.purcPric !== undefined && scope.row.purcPric !== null">
                ¥{{ formatAmount(scope.row.purcPric) }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          
          <!-- 当前出库成本 -->
          <el-table-column
            prop="currentOutCost"
            label="当前出库成本"
            width="140"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.currentOutCost !== undefined && scope.row.currentOutCost !== null">
                ¥{{ formatAmount(scope.row.currentOutCost) }}
              </span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          
          <!-- 规格 -->
          <el-table-column
            prop="specDesc"
            label="规格"
            width="120"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.specDesc || '--' }}
            </template>
          </el-table-column>
          
          <!-- 库存ID -->
          <el-table-column
            prop="invId"
            label="库存ID"
            width="100"
            align="center"
            v-if="currentMode === 'view'"
          >
            <template slot-scope="scope">
              {{ scope.row.invId || '--' }}
            </template>
          </el-table-column>
          
          <!-- 操作列 -->
          <el-table-column
            label="操作"
            width="150"
            align="center"
            fixed="right"
            v-if="currentMode === 'add' || currentMode === 'edit'"
          >
            <template slot-scope="scope">
              <!-- 锁定状态：修改、移除 -->
              <template v-if="scope.row.isLocked && !scope.row.isEditing">
                <!-- 修改按钮 -->
                <el-button
                  type="text"
                  size="mini"
                  @click="handleEditRow(scope.row, scope.$index)"
                  v-if="currentMode === 'edit'"
                >
                  修改
                </el-button>
                
                <!-- 移除按钮 -->
                <el-button
                  type="text"
                  size="mini"
                  style="color: #F56C6C;"
                  @click="handleRemoveRow(scope.row, scope.$index)"
                >
                  移除
                </el-button>
              </template>
              
              <!-- 编辑状态：取消、移除 -->
              <template v-else-if="scope.row.isEditing">
                <!-- 修改模式下不显示保存按钮，只显示取消和移除 -->
                <!-- 取消按钮 -->
                <el-button
                  type="text"
                  size="mini"
                  class="cancel-btn"
                  @click="handleCancelEdit(scope.row, scope.$index)"
                >
                  取消
                </el-button>
                
                <!-- 移除按钮 -->
                <el-button
                  type="text"
                  size="mini"
                  style="color: #F56C6C;"
                  @click="handleRemoveRow(scope.row, scope.$index)"
                >
                  移除
                </el-button>
              </template>
              
              <!-- 新增状态：移除 -->
              <template v-else>
                <!-- 新增模式下只显示移除按钮 -->
                <el-button
                  type="text"
                  size="mini"
                  style="color: #F56C6C;"
                  @click="handleRemoveRow(scope.row, scope.$index)"
                >
                  移除
                </el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
        
        <!-- 合计行 -->
        <div class="summary-row" v-if="medicineList.length > 0">
          <div class="summary-item">
            <span class="summary-label">总出库数量：</span>
            <span class="summary-value">{{ totalOutQuantity }}</span>
          </div>
          <div class="summary-item">
            <span class="summary-label">总出库成本：</span>
            <span class="summary-value">¥{{ formatAmount(totalOutCost) }}</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 模态框底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <!-- 查看模式 -->
      <template v-if="currentMode === 'view'">
        <el-button @click="handlePrint" size="mini" :disabled="true">打印</el-button>
        <el-button @click="handleScreenshot" size="mini" type="primary" :disabled="true">截图保存</el-button>
        <el-button @click="handleClose" size="mini">关闭</el-button>
      </template>
      
      <!-- 新增模式 -->
      <template v-else-if="currentMode === 'add'">
        <el-button @click="handleClose" size="mini">关闭</el-button>
        <el-button 
          @click="handleSaveDraft" 
          size="mini" 
          type="info"
          :disabled="!canSave"
          :loading="submitLoading"
        >
          存为草稿
        </el-button>
        <el-button 
          @click="handleSaveSubmit" 
          size="mini" 
          type="primary"
          :disabled="!canSave"
          :loading="submitLoading"
        >
          保存提交
        </el-button>
      </template>
      
      <!-- 修改模式 -->
      <template v-else-if="currentMode === 'edit'">
        <el-button @click="handleClose" size="mini">关闭</el-button>
        <el-button 
          @click="handleSaveDraft" 
          size="mini" 
          type="info"
          :disabled="!canSave"
          :loading="submitLoading"
        >
          保存草稿
        </el-button>
        <el-button 
          @click="handleSaveSubmit" 
          size="mini" 
          type="primary"
          :disabled="!canSave"
          :loading="submitLoading"
        >
          保存提交
        </el-button>
      </template>
      
      <!-- 提交模式 -->
      <template v-else-if="currentMode === 'submit'">
        <el-button @click="handleClose" size="mini">关闭</el-button>
        <el-button 
          @click="handleSubmitReview" 
          size="mini" 
          type="primary"
          :loading="submitLoading"
        >
          提交审核
        </el-button>
      </template>
      
      <!-- 审核模式 -->
      <template v-else-if="currentMode === 'review'">
        <el-button @click="handleClose" size="mini">关闭</el-button>
        <el-button @click="handleRollbackDraft" size="mini" type="warning">回退草稿</el-button>
        <el-button 
          @click="handleReviewPass" 
          size="mini" 
          type="primary"
          :loading="submitLoading"
        >
          审核过单
        </el-button>
      </template>
      
      <!-- 过单模式 -->
      <template v-else-if="currentMode === 'pass'">
        <el-button @click="handleClose" size="mini">关闭</el-button>
        <el-button @click="handleRollbackSubmit" size="mini" type="warning">回退提交</el-button>
        <el-button 
          @click="handlePassOutbound" 
          size="mini" 
          type="primary"
          :loading="submitLoading"
        >
          过单出库
        </el-button>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import { addSupplierEntity } from "@/api/PSI.js";
import { findAttribute,getActiveList } from "@/api/user.js"
import {
  selectDropDownList,
  selectWCDrug,
  addWCOutbound,
  selectYFtoYKDrug,
  toRetnWCExamine,
  editWCdocOut,
  selectOut,
  docOutWCJoin
} from "@/api/PSI/shopReturn.js";

export default {
  name: 'AddWckModal',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    mode: {
      type: String,
      default: 'add' // add, edit, view, submit, review, pass
    },
    rowData: {
      type: Object,
      default: () => ({})
    },
    putinTypeList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: false,
      currentMode: 'add',
      purchaseForm: {
        warehouseId: 9, // 出库药库，默认1卫材库
        businessDate: this.getCurrentDate(), // 业务日期
        invoiceNo: '', // 发票号码
		deptId: '', // 科室
        supplierId: '', // 供货单位ID
        supplierNo: '', // 供应商号码
        outTypeId: 11, // 出库方式ID，默认11采购退库
        remarks: '' // 备注
      },
	  searchQuery: '', // 搜索关键词
	  loadingMore: false, // 是否正在加载更多
	  showLoadMore: false, // 是否显示加载更多按钮
	  isSearching: false, // 是否正在搜索
      purchaseRules: {
        warehouseId: [
          { required: true, message: '请选择出库药库', trigger: 'change' }
        ],
        businessDate: [
          { required: true, message: '请选择业务日期', trigger: 'change' }
        ],
        supplierId: [
          { required: true, message: '请选择供货单位', trigger: 'change' }
        ],
        outTypeId: [
          { required: true, message: '请选择出库方式', trigger: 'change' }
        ],
      },
      warehouseOptions: [{ id: 9, name: '卫材库' }],
      userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
      supplierOptions: [], // 供货单位选项
      deptOptions: [], // 出库科室选项
      outTypeOptions: [], // 出库方式选项
      medicineList: [], // 药品明细列表
      drugOptions: [], // 药品选项
      tableLoading: false,
      submitLoading: false,
      drugLoading: false,
      
      // 分页参数
      pageNum: 1,
      pageSize: 50,
      totalDrugs: 0,
      eisaiName: '', // 药品搜索名称
      // 医生相关数据
	  staffOptions: [], // 医生选项
	  staffLoading: false, // 医生加载状态
      // 当前编辑的行索引
      editingRowIndex: -1
    };
  },
  computed: {
    getDialogTitle() {
        const titleMap = {
          'add': '创建卫材库出库单',
          'edit': `修改 - ${this.rowData?.docNum || ''}`,
          'view': `查看出库单-${this.rowData?.docNum || ''}的详情`,
          'submit': `提交${this.rowData?.docNum || ''}的出库单`,
          'review': `审核${this.rowData?.docNum || ''}的出库单`,
          'pass': `确认过单${this.rowData?.docNum || ''}完成出库`
        };
        return titleMap[this.currentMode] || '出库单';
      },
	// 总出库数量
	totalOutQuantity() {
	  // 在详情、修改、提交、审核、过单模式下，显示接口返回的列表长度
	  if (['view', 'edit', 'submit', 'review', 'pass'].includes(this.currentMode)) {
	    return this.medicineList.length;
	  } else {
	    // 新增模式下，计算每行出库数量的累加
	    return this.medicineList.reduce((total, item) => {
	      const quantity = parseFloat(item.outQuantity) || 0;
	      return total + quantity;
	    }, 0);
	  }
	},
	// 总出库成本（使用当前出库成本累加）
	totalOutCost() {
	  return this.medicineList.reduce((total, item) => {
	    const cost = parseFloat(item.currentOutCost) || 0;
	    return total + cost;
	  }, 0);
	},
	// 总出库零售（使用当前出库零售累加）
	totalOutSale() {
	  return this.medicineList.reduce((total, item) => {
	    const sale = parseFloat(item.currentOutSale) || 0;
	    return total + sale;
	  }, 0);
	},
    // 是否可以保存（新增/修改模式下）
    canSave() {
      console.log('检查是否可以保存，当前模式:', this.currentMode);
      
      // 只有在新增和修改模式下才需要检查保存条件
      if (this.currentMode !== 'add' && this.currentMode !== 'edit') {
        return true;
      }
      
      // 检查必填字段
      if (!this.purchaseForm.warehouseId || 
          !this.purchaseForm.supplierId || 
          !this.purchaseForm.outTypeId) {
        console.log('采购信息不完整，缺少必填字段');
        return false;
      }
      
      // 检查药品明细列表是否有数据
      if (this.medicineList.length === 0) {
        console.log('药品明细列表为空');
        return false;
      }
      
      // 检查是否有行处于编辑状态
      const hasEditingRows = this.medicineList.some(item => item.isEditing);
      if (hasEditingRows) {
        console.log('有行处于编辑状态，禁用底部按钮');
        return false;
      }
      
      // 新增模式和修改模式的区别处理
      if (this.currentMode === 'add') {
        // 新增模式下，检查所有行是否都已通过库存验证
        for (let i = 0; i < this.medicineList.length; i++) {
          const item = this.medicineList[i];
          console.log(`新增模式 - 第${i + 1}行状态:`, {
            eisaiName: item.eisaiName,
            isLocked: item.isLocked,
            verified: item.verified,
            outQuantity: item.outQuantity,
            eisaiId: item.eisaiId
          });
          
          // 在新增模式下，检查行是否已验证
          if (!item.isLocked && !item.verified) {
            console.log(`第${i + 1}行未验证，禁用底部按钮`);
            return false;
          }
          
          // 检查是否有必需的药品信息
          if (!item.eisaiId || !item.outQuantity) {
            console.log(`第${i + 1}行缺少药品信息或出库数量`);
            return false;
          }
        }
      } else if (this.currentMode === 'edit') {
        // 修改模式下，检查所有行是否都已锁定
        for (let i = 0; i < this.medicineList.length; i++) {
          const item = this.medicineList[i];
          console.log(`修改模式 - 第${i + 1}行状态:`, {
            eisaiName: item.eisaiName,
            isLocked: item.isLocked,
            isEditing: item.isEditing
          });
          
          if (!item.isLocked) {
            console.log(`第${i + 1}行未锁定，禁用底部按钮`);
            return false;
          }
        }
      }
      
      console.log('所有条件满足，启用底部按钮');
      return true;
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.dialogVisible = newVal;
        if (newVal) {
          this.initData();
        }
      }
    },
    mode: {
      immediate: true,
      handler(newVal) {
        this.currentMode = newVal;
      }
    },
    rowData: {
      immediate: true,
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.loadRowData(newVal);
        } else {
          this.resetPurchaseForm();
        }
      }
    },
	// 监听出库科室变化
	  'purchaseForm.deptId': {
	    handler(newVal, oldVal) {
	      console.log('出库科室变化:', {
	        新值: newVal,
	        旧值: oldVal,
	        模式: this.currentMode
	      });
	      
	      // 如果科室ID发生变化，重新加载医生列表
	      if (newVal !== oldVal) {
	        this.loadStaffOptions(newVal);
	      }
	      
	      // 如果科室被清空，清空医生选项
	      if (!newVal) {
	        this.staffOptions = [];
	        this.purchaseForm.staffId = '';
	      }
	    },
	    immediate: false
	  },
    'purchaseForm.warehouseId': {
      handler(newVal) {
        if (newVal) {
          this.loadDrugOptions();
        } else {
          this.drugOptions = [];
        }
      }
    }
  },
  mounted() {
    this.loadSupplierOptions();
	this.fetchDeptOptions();
    this.loadOutTypeOptions();
  },
  beforeDestroy() {
    // 移除滚动事件监听
    const popper = document.querySelector('.drug-select-popper .el-select-dropdown__wrap');
    if (popper) {
      popper.removeEventListener('scroll', this.handleSelectScroll);
    }
  },
  methods: {
    // 获取当前日期
    getCurrentDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    
    // 初始化数据
    async initData() {
      if (this.currentMode === 'add') {
        this.resetPurchaseForm();
        this.medicineList = [];
        // 加载药品选项
        this.loadDrugOptions();
      }
    },
    
    // 加载供货单位选项
    async loadSupplierOptions() {
      try {
        const response = await selectDropDownList();
        if (response && response.code === 200 && response.data) {
          this.supplierOptions = response.data.content;
        } else {
          this.supplierOptions = [];
        }
      } catch (error) {
        console.error('加载供货单位列表失败:', error);
        this.$message.error('加载供货单位列表失败');
        this.supplierOptions = [];
      }
    },
    
	// 获取科室选项
	async fetchDeptOptions() {
		try {
			const clinicId = this.userInfo.clinicId
			if (clinicId) {
				const res = await findAttribute({
					clinicId
				})
				if (res && res.data) {
					this.deptOptions = res.data
					console.log('获取科室选项111:', this.deptOptions)
				}
			}
		} catch (error) {
			console.error('获取科室选项失败:', error)
		}
	},
	
	// 新增：加载医生列表
	async loadStaffOptions(deptId) {
	  if (!deptId) {
	    console.log('科室ID为空，清空医生选项');
	    this.staffOptions = [];
	    this.purchaseForm.staffId = ''; // 清空医生选择
	    return;
	  }
	  
	  try {
	    this.staffLoading = true;
	    console.log('加载医生列表，科室ID:', deptId);
	    
	    const response = await getActiveList({ deptId });
	    
	    if (response && response.code === 200 && response.data) {
	      this.staffOptions = response.data.map(item => ({
	        id: item.id,
	        staffName: item.fullName,
	        titleName: item.userCode
	      }));
	      
	      console.log('医生列表加载成功:', this.staffOptions.length, '个医生');
	      
	      // 如果只有一位医生，默认选中
	      if (this.staffOptions.length === 1) {
	        this.purchaseForm.staffId = this.staffOptions[0].id;
	        console.log('只有一位医生，默认选中:', this.staffOptions[0].staffName);
	      }
	    } else {
	      console.error('加载医生列表失败:', response?.message);
	      this.staffOptions = [];
	      this.$message.error('加载医生列表失败');
	    }
	  } catch (error) {
	    console.error('加载医生列表失败:', error);
	    this.staffOptions = [];
	    this.$message.error('加载医生列表失败: ' + (error.message || '网络错误'));
	  } finally {
	    this.staffLoading = false;
	  }
	},
	
    // 加载出库方式选项
    async loadOutTypeOptions() {
      try {
        const response = await selectOut();
        if (response && response.code === 200 && response.data) {
          this.outTypeOptions = response.data;
        } else {
          this.outTypeOptions = [];
        }
      } catch (error) {
        console.error('加载出库方式列表失败:', error);
        this.$message.error('加载出库方式列表失败');
        this.outTypeOptions = [];
      }
    },
    
    // 加载药品选项
    async loadDrugOptions(isLoadMore = false) {
      if (!this.purchaseForm.warehouseId) {
        this.drugOptions = [];
        return;
      }
      
      try {
        this.drugLoading = true;
        let response = null;
        const params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          eisaiName: this.eisaiName
        };
        
        if (this.purchaseForm.warehouseId === 9) {
          // 卫材库
          response = await selectWCDrug(params);
        } else if (this.purchaseForm.warehouseId === 2) {
          // 卫材房
          response = await selectYFtoYKDrug(params);
        }
        
        if (response && response.code === 200) {
          const newDrugs = response.data.content || response.data || [];
          if (isLoadMore) {
            // 加载更多，合并数据
            this.drugOptions = [...this.drugOptions, ...newDrugs];
          } else {
            // 新搜索，替换数据
            this.drugOptions = newDrugs;
          }
          this.totalDrugs = response.data.totalSize || 0;
        } else {
          this.drugOptions = [];
          this.totalDrugs = 0;
        }
      } catch (error) {
        console.error('加载药品列表失败:', error);
        this.$message.error('加载药品列表失败');
        this.drugOptions = [];
        this.totalDrugs = 0;
      } finally {
        this.drugLoading = false;
      }
    },
    
    // 添加远程搜索方法
    handleRemoteSearch(query) {
      console.log('远程搜索:', query);
      this.searchQuery = query;
      this.pageNum = 1;
      this.isSearching = true;
      this.loadDrugOptions();
    },
    
    // 添加选择框获取焦点方法
    handleSelectFocus() {
      if (this.drugOptions.length === 0 && !this.drugLoading) {
        this.pageNum = 1;
        this.searchQuery = '';
        this.isSearching = false;
        this.loadDrugOptions();
      }
    },
    
    // 添加选择框显示/隐藏变化方法
    handleSelectVisibleChange(visible) {
      if (visible && this.drugOptions.length === 0 && !this.drugLoading) {
        this.pageNum = 1;
        this.searchQuery = '';
        this.isSearching = false;
        this.loadDrugOptions();
      }
    },
    
    // 添加加载更多方法
    loadMoreDrugs() {
      if (this.loadingMore) return;
      
      this.pageNum++;
      this.loadDrugOptions(true);
    },
    
    // 修改药品搜索方法
    handleDrugSearch() {
      this.pageNum = 1;
      this.isSearching = true;
      this.loadDrugOptions();
    },
    
    // 处理选择框显示/隐藏
    handleSelectVisible(visible) {
      if (visible) {
        // 选择框显示时，绑定滚动事件
        this.$nextTick(() => {
          this.bindSelectScroll();
        });
      }
    },
    
    // 绑定选择框滚动事件
    bindSelectScroll() {
      const popper = document.querySelector('.drug-select-popper .el-select-dropdown__wrap');
      if (popper) {
        popper.addEventListener('scroll', this.handleSelectScroll);
      }
    },
    
    // 处理选择框滚动
    handleSelectScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      const threshold = 50; // 距离底部50px时触发加载
      
      // 如果滚动到底部，并且还有更多数据，则加载更多
      if (scrollHeight - scrollTop - clientHeight < threshold) {
        if (!this.drugLoading && this.drugOptions.length < this.totalDrugs) {
          this.loadMoreDrugs();
        }
      }
    },
	
    // 在loadRowData方法中修改
    loadRowData(rowData) {
      console.log('加载行数据:', rowData);
      
      // 填充采购信息
        this.purchaseForm = {
          warehouseId: rowData.shedId || 9,
          businessDate: rowData.businessDate || this.getCurrentDate(),
          invoiceNo: rowData.invoiceNo || '',
          deptId: rowData.deptId || '',
          supplierId: rowData.supplyCandidateId || null,
          supplierNo: rowData.supplierNo || '',
          outTypeId: rowData.retnTypeId || 11,
          staffId: rowData.staffId || '', // 新增：医生ID
          remarks: rowData.remarks || ''
        };
        
        // 如果存在科室ID，加载医生列表
        if (this.purchaseForm.deptId) {
          console.log('行数据中有科室ID，加载医生列表:', this.purchaseForm.deptId);
          this.$nextTick(() => {
            this.loadStaffOptions(this.purchaseForm.deptId);
          });
        }
      
      // 加载药品明细
      if (rowData.list && Array.isArray(rowData.list)) {
        this.medicineList = rowData.list.map(item => {
          // 在详情、修改、提交、审核、过单模式下，出库数量取retnCnt
          const outQuantity = ['view', 'edit', 'submit', 'review', 'pass'].includes(this.currentMode) 
            ? (item.retnCnt || item.apllyAmt || '')
            : (item.apllyAmt || '');
          
          // 计算当前出库成本和零售
          const currentOutCost = parseFloat(item.purcAmt) || 0;
          const currentOutSale = parseFloat(item.saleAmt) || 0;
          
          return {
            id: item.id || null,
            eisaiId: item.eisaiId || null,
            eisaiName: item.eisaiName || '',
            purcCnt: item.purcCnt || '',
            outQuantity: outQuantity,
            stockType: item.purcType || 2,
            pacCnt: item.pacCnt || '',
            prodentpName: item.prodentpName || '',
            manuLotnum: item.manuLotnum || '',
            manuDate: item.manuDate || '',
            expyDate: item.expyDate || '',
            purcPric: item.purcPric || '',
            currentOutCost: currentOutCost,
            salePric: item.salePric || '',
            currentOutSale: currentOutSale,
            specDesc: item.specDesc || '',
            unit: item.unt || '',
            dosUnt: item.dosUnt || '',
            pacUnt: item.pacUnt || '',
            invId: item.invId || null,
            prodentpNameId: item.prodentpNameId || null,
            isLocked: true,
            isEditing: false,
            hasChanged: false,
            originalData: JSON.parse(JSON.stringify(item))
          };
        });
      } else {
        this.medicineList = [];
      }
      
      // 如果有关联药库，加载对应药品选项
      if (rowData.shedId) {
        this.loadDrugOptions();
      }
    },
    
   // 修改：重置采购表单
   resetPurchaseForm() {
     this.purchaseForm = {
       warehouseId: 9, // 默认卫材库
       businessDate: this.getCurrentDate(),
       invoiceNo: '',
       deptId: '',
       supplierId: null,
       supplierNo: '',
       outTypeId: 11, // 默认采购退库
       staffId: '', // 新增：清空医生ID
       remarks: ''
     };
     this.medicineList = [];
     this.staffOptions = []; // 清空医生选项
     this.pageNum = 1;
     this.eisaiName = '';
   },
    
    // 添加药品行
    addMedicineRow() {
      const newRow = {
        id: null,
        drugId: null,
        drugName: '',
        purcCnt: '',
        outQuantity: '',
        stockType: 2, // 默认包装单位
        pacCnt: '',
        prodentpName: '',
        manuLotnum: '',
        manuDate: '',
        expyDate: '',
        purcPric: '', // 入库成本
        currentOutCost: '', // 当前出库成本
        salePric: '', // 入库零售
        currentOutSale: '', // 当前出库零售
        drugSpec: '',
        unit: '', // 单位文字
        dosUnt: '', // 最小单位
        pacUnt: '', // 包装单位
        invId: null, // 库存ID
        prodentpNameId: null, // 生产厂家ID
        // 关键修改：根据模式设置初始状态
        isLocked: false, // 任何模式下新增行都未锁定
        // 关键修改：在“修改模式”下，新增行应处于编辑状态，以便触发自动验证
        isEditing: this.currentMode === 'edit', 
        hasChanged: false, // 无变化
        checkingStock: false, // 是否正在验证库存
        verified: this.currentMode === 'add', // 仅在新增模式下初始为已验证？不，应为false
        verificationResult: null, // 验证结果
        originalData: null // 无原始数据
      };
      
      // 确保 verified 初始状态正确
      if (this.currentMode === 'add') {
        newRow.verified = false; // 新增模式下，新行也未验证
      }
      
      this.medicineList.push(newRow);
      console.log(`新增药品行（模式：${this.currentMode}），isEditing: ${newRow.isEditing}，当前行数:`, this.medicineList.length);
    },
    
	// 保存已验证的行
	handleSaveVerifiedRow(row, index) {
	  if (!row.verified) {
	    this.$message.warning('该行尚未通过库存验证');
	    return;
	  }
	  
	  // 锁定已验证的行
	  row.isLocked = true;
	  row.isEditing = false;
	  row.verified = false;
	  row.originalData = JSON.parse(JSON.stringify(row));
	  
	  this.$message.success('已保存药品信息');
	},
	
    // 处理药库变更
    handleWarehouseChange(value) {
      this.medicineList.forEach(item => {
        if (!item.isLocked) {
          // 重置非锁定的药品行
          this.resetMedicineRow(item);
        }
      });
      this.loadDrugOptions();
    },
    
    // 处理供货单位变更
    handleSupplierChange(value) {
      const selectedSupplier = this.supplierOptions.find(item => item.id === value);
      if (selectedSupplier && selectedSupplier.supplierNo) {
        this.purchaseForm.supplierNo = selectedSupplier.supplierNo;
      }
    },
    
	// 判断是否显示当前库存列
	shouldShowPurcCnt(index) {
	  const row = this.medicineList[index];
	  
	  // 在详情、提交、审核、过单模式下不显示
	  if (['view', 'submit', 'review', 'pass'].includes(this.currentMode)) {
	    return false;
	  }
	  
	  // 在修改模式下
	  if (this.currentMode === 'edit') {
	    // 如果行处于锁定状态且不是编辑状态，不显示
	    if (row.isLocked && !row.isEditing) {
	      return false;
	    }
	    // 如果行处于编辑状态但没有选择药品，不显示
	    if (row.isEditing && !row.eisaiId) {
	      return false;
	    }
	  }
	  
	  return true;
	},
	
    // 处理药品选择变更
    handleDrugChange(eisaiId, row, index) {
      console.log('药品选择变更:', eisaiId, '行索引:', index);
      
      if (!eisaiId) {
        console.log('清空药品选择');
        this.resetMedicineRow(row);
        row.hasChanged = this.checkRowChanged(row);
        return;
      }
      
      const selectedDrug = this.drugOptions.find(item => item.eisaiId === eisaiId);
      if (selectedDrug) {
        console.log('找到选中药品:', selectedDrug);
        
        // 填充药品信息
        row.eisaiName = selectedDrug.eisaiName;
        row.purcCnt = selectedDrug.purcCnt || '';
        row.pacCnt = selectedDrug.pacCnt || '';
        row.manuLotnum = selectedDrug.manuLotnum || '';
        row.prodentpName = selectedDrug.prodentpName || '';
        row.manuDate = selectedDrug.manuDate || '';
        row.expyDate = selectedDrug.expyDate || '';
        // 获取入库成本 - 从selectWCDrug接口返回的purcPric字段
        row.purcPric = selectedDrug.purcPric || '';
        row.salePric = selectedDrug.salePric || '';
        row.specDesc = selectedDrug.specDesc || '';
        row.dosUnt = selectedDrug.dosUnt || '';
        row.pacUnt = selectedDrug.pacUnt || '';
        
        // 关键：保存库存ID
        row.invId = selectedDrug.id || selectedDrug.invId;
        console.log('保存库存ID:', row.invId, '来源数据:', {
          invyId: selectedDrug.invyId,
          invId: selectedDrug.invId
        });
        
        row.prodentpNameId = selectedDrug.prodentpNameId || null;
        row.unit = row.pacUnt; // 默认显示包装单位
        
        // 清除验证状态，因为药品已更改
        row.verified = false;
        row.verificationResult = null;
        
        // 计算当前出库成本和零售
        this.calculateRowAmounts(row);
        row.hasChanged = this.checkRowChanged(row);
        
        console.log(`药品${selectedDrug.eisaiName}信息已填充，purcPric:`, row.purcPric, 'salePric:', row.salePric);
        
        // 如果已经有出库数量，自动触发库存验证
        if (row.outQuantity && this.currentMode === 'add') {
          console.log('已有出库数量，准备触发自动验证');
          // 使用setTimeout确保数据更新完成后再验证
          this.$nextTick(() => {
            setTimeout(() => {
              this.autoStockCheck(row, index);
            }, 500);
          });
        }
      } else {
        console.log('未找到对应药品，eisaiId:', eisaiId);
      }
    },
    
    // 处理出库数量变更
    handleQuantityChange(value, row, index) {
      // 验证只能输入大于0的正数
      const numValue = parseFloat(value);
      if (isNaN(numValue) || numValue <= 0) {
        this.$message.warning('出库数量必须为大于0的数字');
        row.outQuantity = '';
        row.currentOutCost = '';
        row.currentOutSale = '';
        row.hasChanged = this.checkRowChanged(row);
        return;
      }
      
      // 检查是否为小数
      if (numValue % 1 !== 0) {
        // 如果是小数，设置为最小单位
        row.stockType = 1;
        row.unit = row.dosUnt;
      } else {
        // 如果是整数，保持原库存类型
        if (!row.stockType) {
          row.stockType = 2;
          row.unit = row.pacUnt;
        }
      }
      
      // 重新计算金额
      this.calculateRowAmounts(row);
      row.hasChanged = this.checkRowChanged(row);
      
      // 在修改模式下，如果行处于编辑状态，自动触发验证
      if (this.currentMode === 'edit' && row.isEditing && row.eisaiId && row.outQuantity && row.invId) {
		this.$nextTick(() => {
		  setTimeout(() => {
		    this.autoStockCheck(row, index, true);
		  }, 300);
		});
      }
      // 新增模式保持原有逻辑
      else if (this.currentMode === 'add' && row.eisaiId && row.outQuantity && row.invId) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.autoStockCheck(row, index, true);
          }, 300);
        });
      }
    },
    
    // 处理库存类型变更
    handleStockTypeChange(value, row) {
      row.stockType = value;
      row.unit = value === 1 ? row.dosUnt : row.pacUnt;
      this.calculateRowAmounts(row);
      row.hasChanged = this.checkRowChanged(row);
      
      // 在修改模式下，如果行处于编辑状态，自动触发验证
      if (this.currentMode === 'edit' && row.isEditing && row.eisaiId && row.outQuantity && row.invId) {
        this.autoStockCheck(row, this.medicineList.indexOf(row), true);
      }
      // 新增模式保持原有逻辑
      else if (this.currentMode === 'add' && row.eisaiId && row.outQuantity && row.invId) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.autoStockCheck(row, this.medicineList.indexOf(row), true);
          }, 300);
        });
      }
    },
    
	// 自动库存验证
	async autoStockCheck(row, index, isManual = false) {
	  if (!row.eisaiId || !row.outQuantity) {
	    return;
	  }
	  
	  // 检查是否有invId
	  if (!row.invId) {
	    this.$message.warning('未获取到库存ID，请重新选择药品');
	    return;
	  }
	  
	  // 防止频繁调用
	  if (row.checkingStock) {
	    return;
	  }
	  
	  try {
	    row.checkingStock = true;
	    this.tableLoading = true;
	    
	    const params = {
	      amount: row.outQuantity, // 出库数量
	      invId: row.invId, // 库存ID
	      purcType: row.stockType // 库存类型
	    };
	    
	    console.log('自动库存验证参数:', params);
	    
	    const response = await docOutWCJoin(params);
	    if (response && response.code === 200) {
	      // 验证成功
	      if (this.currentMode === 'edit' && row.isEditing) {
	        // 修改模式下，验证成功，锁定行并退出编辑状态
	        row.isLocked = true;
	        row.isEditing = false;
	        row.hasChanged = false;
	        row.originalData = JSON.parse(JSON.stringify(row));
	        
	        // 隐藏操作列中的保存按钮
	        this.editingRowIndex = -1;
	        
	        this.$message.success(`已成功将${row.eisaiName}修改并锁定`);
	      } else if (this.currentMode === 'add') {
	        // 新增模式下，验证成功，标记为已验证
	        row.verified = true;
	        row.hasChanged = false;
	        
	        this.$message.success(`已成功将${row.eisaiName}添加至出库明细表！`);
	      }
	      
	      // 验证成功后，更新金额字段
	      if (response.data && response.code === 200) {
	        const firstItem = response.data;
	        // 更新单价
	        row.purcPric = firstItem.purcPric || row.purcPric;
	        row.salePric = firstItem.salePric || row.salePric;
	        
	        // 计算当前出库成本 = 接口返回的purcPric * 接口返回的apllyAmt
	        const purcPric = parseFloat(firstItem.purcPric) || 0;
	        const apllyAmt = parseFloat(firstItem.apllyAmt) || 0;
	        row.currentOutCost = purcPric * apllyAmt;
	        
	        // 计算当前出库零售 = 接口返回的salePric * 接口返回的apllyAmt
	        const salePric = parseFloat(firstItem.salePric) || 0;
	        row.currentOutSale = salePric * apllyAmt;
	        
	        console.log('更新金额字段:', {
	          purcPric: firstItem.purcPric,
	          salePric: firstItem.salePric,
	          apllyAmt: firstItem.apllyAmt,
	          currentOutCost: row.currentOutCost,
	          currentOutSale: row.currentOutSale
	        });
	      }
	    } else {
	      // 验证失败
	      this.$message.error(response?.message || '库存验证失败');
	      
	      if (this.currentMode === 'edit' && row.isEditing) {
	        // 修改模式下验证失败，保持编辑状态，不锁定
	        row.isLocked = false;
	        row.isEditing = true; // 保持编辑状态
	        row.hasChanged = true; // 保持有变化状态
	        
	        // 验证失败时不启用底部按钮
	        console.log('修改模式验证失败，保持编辑状态，不启用底部按钮');
	      } else if (this.currentMode === 'add') {
	        // 新增模式下验证失败
	        row.verified = false;
	        row.hasChanged = true;
	      }
	    }
	  } catch (error) {
	    console.error('自动库存验证失败:', error);
	    this.$message.error('库存验证失败，请稍后重试');
	    
	    if (this.currentMode === 'edit' && row.isEditing) {
	      row.isLocked = false;
	      row.isEditing = true; // 保持编辑状态
	      row.hasChanged = true; // 保持有变化状态
	    } else if (this.currentMode === 'add') {
	      row.verified = false;
	      row.hasChanged = true;
	    }
	  } finally {
	    row.checkingStock = false;
	    this.tableLoading = false;
	  }
	},
	
    // 计算当前行的出库成本和零售
    calculateRowAmounts(row) {
      const quantity = parseFloat(row.outQuantity) || 0;
      const costPrice = parseFloat(row.purcPric) || 0;  // 入库成本
      const salePrice = parseFloat(row.salePric) || 0;  // 入库零售
      
      // 只有在没有验证的情况下才使用本地计算
      if (!row.verified && !row.isLocked) {
        row.currentOutCost = quantity * costPrice;
        row.currentOutSale = quantity * salePrice;
      }
      // 如果已经验证，金额将由验证接口返回，这里不重新计算
    },
    
    // 重置药品行
    resetMedicineRow(row) {
      row.eisaiId = null;
      row.eisaiName = '';
      row.purcCnt = '';
      row.outQuantity = '';
      row.stockType = 2;
      row.pacCnt = '';
      row.prodentpName = ''; // 注意字段名
      row.manuLotnum = '';
      row.manuDate = '';
      row.expyDate = '';
      row.purcPric = '';
      row.currentOutCost = '';
      row.salePric = '';
      row.currentOutSale = '';
      row.specDesc = '';
      row.unit = '';
      row.dosUnt = '';
      row.pacUnt = '';
      row.invId = null;
      row.prodentpNameId = null;
      row.hasChanged = this.checkRowChanged(row);
    },
    
    // 计算当前出库成本
    calculateCurrentOutCost(item) {
      const quantity = parseFloat(item.outQuantity) || 0;
      const costPrice = parseFloat(item.purcPric) || 0;
      return quantity * costPrice;
    },
    
    // 计算当前出库零售
    calculateCurrentOutSale(item) {
      const quantity = parseFloat(item.outQuantity) || 0;
      const salePrice = parseFloat(item.salePric) || 0;
      return quantity * salePrice;
    },
    
    // 检查行数据是否变化
    checkRowChanged(row) {
      if (!row.originalData) {
        // 如果没有原始数据，说明是新增行
        return !!(row.eisaiId || row.outQuantity);
      }
      
      // 比较关键字段是否变化
      return row.eisaiId !== row.originalData.eisaiId ||
             row.outQuantity !== row.originalData.outQuantity ||
             row.stockType !== row.originalData.stockType;
    },
    
	// 库存验证
	async handleStockCheck(row, index) {
	  if (!row.eisaiId || !row.outQuantity) {
	    this.$message.warning('请先选择药品并填写出库数量');
	    return;
	  }
	  
	  // 检查是否有invId
	  if (!row.invId) {
	    this.$message.warning('未获取到库存ID，请重新选择药品');
	    return;
	  }
	  
	  try {
	    this.tableLoading = true;
	    const params = {
	      amount: row.outQuantity, // 出库数量
	      invId: row.invId, // 库存ID
	      purcType: row.stockType // 库存类型
	    };
	    
	    console.log('库存验证参数:', params);
	    
	    const response = await docOutWCJoin(params);
	    if (response && response.code === 200) {
	      // 库存验证成功，但不更新金额字段
	      // 只锁定行状态
	      row.isLocked = true;
	      row.isEditing = false;
	      row.hasChanged = false;
	      row.originalData = JSON.parse(JSON.stringify(row));
	      
	      this.$message.success(`已为${row.eisaiName}完成库存验证`);
	    } else {
	      this.$message.error(response.message || '库存验证失败');
	    }
	  } catch (error) {
	    console.error('库存验证失败:', error);
	    this.$message.error('库存验证失败');
	  } finally {
	    this.tableLoading = false;
	  }
	},
    
    // 修改行
    handleEditRow(row, index) {
      row.isEditing = true;
      row.hasChanged = false;
      row.originalData = JSON.parse(JSON.stringify(row));
      this.editingRowIndex = index;
    },
    
    // 保存编辑
    async handleSaveEdit(row, index) {
      if (!row.eisaiId || !row.outQuantity) {
        this.$message.warning('请先选择药品并填写出库数量');
        return;
      }
      
      // 检查是否有invId
      if (!row.invId) {
        this.$message.warning('未获取到库存ID，请重新选择药品');
        return;
      }
      
      try {
        this.tableLoading = true;
        const params = {
          amount: row.outQuantity, // 出库数量
          invId: row.invId, // 库存ID
          purcType: row.stockType // 库存类型
        };
        
        const response = await docOutWCJoin(params);
        if (response && response.code === 200) {
          // 验证成功，锁定行并退出编辑状态
          row.isLocked = true;
          row.isEditing = false;
          row.hasChanged = false;
          row.originalData = JSON.parse(JSON.stringify(row));
          this.editingRowIndex = -1;
          
          // 验证成功后，更新金额字段
          if (response.data && response.data.length > 0) {
            const firstItem = response.data[0];
            // 更新单价
            row.purcPric = firstItem.purcPric || row.purcPric;
            row.salePric = firstItem.salePric || row.salePric;
            
            // 计算当前出库成本 = 接口返回的purcPric * 接口返回的apllyAmt
            const purcPric = parseFloat(firstItem.purcPric) || 0;
            const apllyAmt = parseFloat(firstItem.apllyAmt) || 0;
            row.currentOutCost = purcPric * apllyAmt;
            
            // 计算当前出库零售 = 接口返回的salePric * 接口返回的apllyAmt
            const salePric = parseFloat(firstItem.salePric) || 0;
            row.currentOutSale = salePric * apllyAmt;
          }
          
          this.$message.success('修改已保存');
        } else {
          this.$message.error(response.message || '库存验证失败，保存未成功');
          
          // 验证失败，保持编辑状态，不锁定
          row.isLocked = false;
          row.isEditing = true; // 保持编辑状态
          row.hasChanged = true; // 保持有变化状态
        }
      } catch (error) {
        console.error('保存编辑失败:', error);
        this.$message.error('保存编辑失败');
        
        // 异常时也保持编辑状态，不锁定
        row.isLocked = false;
        row.isEditing = true;
        row.hasChanged = true;
      } finally {
        this.tableLoading = false;
      }
    },
    
    // 取消编辑
    handleCancelEdit(row, index) {
      if (row.originalData) {
        // 恢复原始数据
        Object.assign(row, row.originalData);
      }
      row.isEditing = false;
      row.hasChanged = false;
      this.editingRowIndex = -1;
    },
    
    // 移除行
    handleRemoveRow(row, index) {
      if (!row.eisaiId) {
        // 如果未选择药品，直接移除
        this.medicineList.splice(index, 1);
        this.$message.success('已移除');
        return;
      }
      
      // 如果已选择药品，弹出确认提示
      this.$confirm(
        '当前出库表格中您已选择了出库药库，可尝试重新填写其对应的明细，或者点击确定移除此行，进行重新编辑。',
        '确认移除',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        this.medicineList.splice(index, 1);
        this.$message.success('已移除');
      }).catch(() => {
        // 用户取消移除
      });
    },
    
    // 格式化金额（添加千位分隔符）
    formatAmount(amount) {
      if (amount === undefined || amount === null || amount === '') return '0.00';
      
      // 转换为数字
      const num = parseFloat(amount);
      if (isNaN(num)) return '0.00';
      
      // 保留两位小数
      const fixedNum = num.toFixed(8);
      
      // 添加千位分隔符
      const parts = fixedNum.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      
      return parts.join('.');
    },
    
    // 格式化日期
    formatDate(date) {
      if (!date) return '--';
      if (typeof date === 'string') {
        return date.split(' ')[0]; // 只取日期部分
      }
      if (typeof date === 'number') {
        return new Date(date).toISOString().split('T')[0];
      }
      return '--';
    },
    
    // 验证表单
    validateForm() {
      return new Promise((resolve, reject) => {
        this.$refs.purchaseForm.validate((valid) => {
          if (!valid) {
            this.$message.error('请填写完整的采购信息');
            reject(new Error('表单验证失败'));
            return;
          }
          
          if (this.medicineList.length === 0) {
            this.$message.error('请至少添加一条药品明细');
            reject(new Error('药品明细为空'));
            return;
          }
          
          // 验证药品明细
          // for (let i = 0; i < this.medicineList.length; i++) {
          //   const item = this.medicineList[i];
          //   if (!item.eisaiId) {
          //     this.$message.error(`第${i + 1}行：请选择药品`);
          //     reject(new Error(`第${i + 1}行药品未选择`));
          //     return;
          //   }
            
          //   if (!item.outQuantity || parseFloat(item.outQuantity) <= 0) {
          //     this.$message.error(`第${i + 1}行：请输入有效的出库数量`);
          //     reject(new Error(`第${i + 1}行出库数量无效`));
          //     return;
          //   }
            
          //   if (!item.isLocked) {
          //     this.$message.error(`第${i + 1}行：请先完成库存验证`);
          //     reject(new Error(`第${i + 1}行未完成库存验证`));
          //     return;
          //   }
          // }
          
          resolve();
        });
      });
    },
    
    // 修改：准备提交数据
    prepareSubmitData(state) {
      // 计算总成本
      const costAmt = this.medicineList.reduce((total, item) => {
        const retnAmt = parseFloat(item.currentOutCost) || 0;
        return total + retnAmt;
      }, 0);
      
      // 计算总零售
      const saleAmt = this.medicineList.reduce((total, item) => {
        const saleAmtItem = parseFloat(item.currentOutSale) || 0;
        return total + saleAmtItem;
      }, 0);
      
      return {
        costAmt: costAmt, // 出库总成本
        deptId: this.purchaseForm.deptId, // 出库科室ID
        list: this.medicineList.map(item => ({
          retnCnt: parseFloat(item.outQuantity) || 0, // join接口返回的出库数量
          invId: item.invId || 0, // 库存ID
          purcType: item.stockType, // 库存类型
          purcAmt: parseFloat(item.currentOutCost) || 0, // 出库总成本
          purcPric: parseFloat(item.purcPric) || 0, // 入库成本
          saleAmt: parseFloat(item.currentOutCost) || 0, // 出库总零售
          salePric: parseFloat(item.purcPric) || 0, // 入库零售
          unt: item.stockType === 1 ? item.dosUnt : item.pacUnt // 出库单位
        })),
        remarks: this.purchaseForm.remarks, // 备注
        retnTypeId: this.purchaseForm.outTypeId, // 出库方式ID
        saleAmt: costAmt, // 出库总零售
        shedId: this.purchaseForm.warehouseId, // 出库药库ID
        staffId: this.purchaseForm.staffId, // 新增：医生ID
        state: state, // 状态：0草稿，2提交
        supplyCandidateId: this.purchaseForm.supplierId // 供货单位ID
      };
    },
    
    // 保存为草稿
    async handleSaveDraft() {
      try {
        await this.validateForm();
        this.submitLoading = true;
        
        const submitData = this.prepareSubmitData(0); // 草稿状态
        
        let response = null;
        if (this.currentMode === 'add') {
          response = await addWCOutbound(submitData);
        } else if (this.currentMode === 'edit') {
          response = await editWCdocOut({
            ...submitData,
            id: this.rowData.id
          });
        }
        
        if (response && response.code === 200) {
          const drugNames = this.medicineList.map(item => item.eisaiName).join('、');
          this.$message.success(`${this.purchaseForm.businessDate} - ${drugNames}出库单 已完成草稿状态的创建！`);
          this.$emit('success', {
            ...response.data,
            warehouseId: this.purchaseForm.warehouseId
          });
          this.handleClose();
        } else {
          this.$message.error(response.message || '保存草稿失败');
        }
      } catch (error) {
        if (error.message !== '表单验证失败' && 
            error.message !== '药品明细为空' && 
            !error.message.includes('未完成库存验证')) {
          console.error('保存草稿失败:', error);
          this.$message.error('保存草稿失败');
        }
      } finally {
        this.submitLoading = false;
      }
    },
    
    // 保存提交
    async handleSaveSubmit() {
      try {
        await this.validateForm();
        this.submitLoading = true;
        
        const submitData = this.prepareSubmitData(2); // 已提交状态
        
        let response = null;
        if (this.currentMode === 'add') {
          response = await addWCOutbound(submitData);
        } else if (this.currentMode === 'edit') {
          response = await editWCdocOut({
            ...submitData,
            id: this.rowData.id
          });
        }
        
        if (response && response.code === 200) {
          const drugNames = this.medicineList.map(item => item.eisaiName).join('、');
          this.$message.success(`${this.purchaseForm.businessDate} - ${drugNames}出库单 已完成提交状态的创建！`);
          this.$emit('success', {
            ...response.data,
            warehouseId: this.purchaseForm.warehouseId
          });
          this.handleClose();
        } else {
          this.$message.error(response.message || '保存提交失败');
        }
      } catch (error) {
        if (error.message !== '表单验证失败' && 
            error.message !== '药品明细为空' && 
            !error.message.includes('未完成库存验证')) {
          console.error('保存提交失败:', error);
          this.$message.error('保存提交失败');
        }
      } finally {
        this.submitLoading = false;
      }
    },
    
    // 提交审核
    async handleSubmitReview() {
      try {
        await this.validateForm();
        this.submitLoading = true;
        
        const submitData = this.prepareSubmitData(2); // 已提交状态
        
        const response = await toRetnWCExamine({
          ...submitData,
          id: this.rowData.id
        });
        
        if (response && response.code === 200) {
          this.$message.success('提交审核成功');
          this.$emit('success', response.data);
          this.handleClose();
        } else {
          this.$message.error(response.message || '提交审核失败');
        }
      } catch (error) {
        if (error.message !== '表单验证失败' && 
            error.message !== '药品明细为空' && 
            !error.message.includes('未完成库存验证')) {
          console.error('提交审核失败:', error);
          this.$message.error('提交审核失败');
        }
      } finally {
        this.submitLoading = false;
      }
    },
    
    // 审核过单
    async handleReviewPass() {
      try {
        this.submitLoading = true;
        
        const response = await toRetnWCExamine({
          id: this.rowData.id,
          state: 4 // 已审核状态
        });
        
        if (response && response.code === 200) {
          this.$message.success('审核过单成功');
          this.$emit('success', response.data);
          this.handleClose();
        } else {
          this.$message.error(response.message || '审核过单失败');
        }
      } catch (error) {
        console.error('审核过单失败:', error);
        this.$message.error('审核过单失败');
      } finally {
        this.submitLoading = false;
      }
    },
    
    // 过单出库
    async handlePassOutbound() {
      try {
        this.submitLoading = true;
        
        const response = await toRetnWCExamine({
          id: this.rowData.id,
          state: 5 // 已过单状态
        });
        
        if (response && response.code === 200) {
          this.$message.success('过单出库成功');
          this.$emit('success', response.data);
          this.handleClose();
        } else {
          this.$message.error(response.message || '过单出库失败');
        }
      } catch (error) {
        console.error('过单出库失败:', error);
        this.$message.error('过单出库失败');
      } finally {
        this.submitLoading = false;
      }
    },
    
    // 回退草稿
    async handleRollbackDraft() {
      try {
        this.submitLoading = true;
        
        const response = await toRetnWCExamine({
          id: this.rowData.id,
          state: 0 // 提交回退状态
        });
        
        if (response && response.code === 200) {
          this.$message.success('回退草稿成功');
          this.$emit('success', response.data);
          this.handleClose();
        } else {
          this.$message.error(response.message || '回退草稿失败');
        }
      } catch (error) {
        console.error('回退草稿失败:', error);
        this.$message.error('回退草稿失败');
      } finally {
        this.submitLoading = false;
      }
    },
    
    // 回退提交
    async handleRollbackSubmit() {
      try {
        this.submitLoading = true;
        
        const response = await toRetnWCExamine({
          id: this.rowData.id,
          state: 2 // 审核回退状态
        });
        
        if (response && response.code === 200) {
          this.$message.success('回退提交成功');
          this.$emit('success', response.data);
          this.handleClose();
        } else {
          this.$message.error(response.message || '回退提交失败');
        }
      } catch (error) {
        console.error('回退提交失败:', error);
        this.$message.error('回退提交失败');
      } finally {
        this.submitLoading = false;
      }
    },
    
    // 打印
    handlePrint() {
      this.$message.info('打印功能待实现');
    },
    
    // 截图保存
    handleScreenshot() {
      this.$message.info('截图保存功能待实现');
    },
    
    // 关闭对话框
    handleClose() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="less" scoped>
.dialog-container {
  height: 70vh;
  overflow-y: auto;
  padding: 0 20px;
  
  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin: 0 0 15px 0;
    padding-bottom: 8px;
    border-bottom: 1px solid #ebeef5;
  }
  
  .purchase-info-section {
    margin-bottom: 20px;
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    
    .supplier-container {
      display: flex;
      align-items: center;
    }
  }
  
  .medicine-detail-section {
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    
    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      
      .section-title {
        margin: 0;
        border: none;
        padding: 0;
      }
    }
    
    .search-box {
      margin-bottom: 15px;
      display: flex;
      align-items: center;
    }
    
	.out-quantity-container {
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  gap: 8px;
	}
    .pagination-container {
      margin-top: 15px;
      display: flex;
      justify-content: center;
    }
    
    .summary-row {
      margin-top: 20px;
      padding: 15px;
      background-color: #f5f7fa;
      border-radius: 8px;
      display: flex;
      justify-content: flex-end;
      gap: 30px;
      
      .summary-item {
        font-size: 14px;
        color: #606266;
        
        .summary-label {
          font-weight: 500;
        }
        
        .summary-value {
          font-weight: 600;
          color: #409EFF;
          margin-left: 8px;
        }
      }
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 20px;
  border-top: 1px solid #ebeef5;
  
  .el-button {
    margin: 0 10px;
  }
}

.save-btn {
  color: #67C23A;
}

.cancel-btn {
  color: #909399;
}

/* 自定义对话框样式 */
/deep/ .addxyk-dialog {
  border-radius: 8px;
  
  .el-dialog__body {
    padding: 20px 0;
    max-height: calc(85vh - 120px);
    overflow: hidden;
  }
  
  .el-dialog__footer {
    padding: 15px 20px;
  }
}
</style>
<style lang="less">
/* 药品下拉框的全局样式 - 针对挂载在body上的popper */
.drug-select-popper {
  .el-select-dropdown__item {
    height: auto;
    min-height: 50px;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    
    &:hover,
    &.selected,
    &.hover {
      .drug-option {
        .drug-name {
          .highlight-keyword {
            color: #ff6700;
            background-color: rgba(255, 103, 0, 0.15);
          }
        }
      }
    }
    
    .drug-option {
      display: flex;
      flex-direction: column;
      width: 100%;
      line-height: 1.4;
      min-height: 50px;
      
      .drug-name {
        font-weight: 600;
        color: #303133;
        margin-bottom: 3px;
        font-size: 13px;
        
        /* 高亮关键词样式 */
        .highlight-keyword {
          color: #ff6700;
          font-weight: bold;
          background-color: rgba(255, 103, 0, 0.1);
          padding: 0 2px;
          border-radius: 2px;
        }
      }
      
      .drug-spec {
        font-size: 12px;
        color: #606266;
        line-height: 1.3;
        
        &:not(:last-child) {
          margin-bottom: 2px;
        }
      }
    }
  }
}
</style>

<style lang="less" scoped>
/deep/ .el-dialog__header {
	padding-bottom: 10px;
	background: linear-gradient(135deg, #ebfaff 0%, #00557f 100%);
	border-bottom: 1px solid #e8e8e8;
	border-radius: 8px;
	}

/deep/ .el-dialog__headerbtn .el-dialog__close{
	color: #ffffff;
}
/deep/ .el-dialog__headerbtn .el-dialog__close:hover{
	color: #000042;
	font-weight: bold;
}
</style>